'use client';

import { useEffect, useState } from 'react';

import { getAlgoliaFailoverStatus } from '@/config/algoliaFailover';

export const useAlgoliaFailover = () => {
  const [isAlgoliaDown, setIsAlgoliaDown] = useState(getAlgoliaFailoverStatus());

  useEffect(() => {
    // Check for status changes every few seconds to catch global state updates
    const statusCheckInterval = setInterval(() => {
      const currentStatus = getAlgoliaFailoverStatus();
      setIsAlgoliaDown(currentStatus);
    }, 3000);

    return () => clearInterval(statusCheckInterval);
  }, []);

  useEffect(() => {
    if (!isAlgoliaDown) {
      return;
    }

    // This interval is for the detailed health checking when down
    const healthCheckInterval = setInterval(() => {
      const currentStatus = getAlgoliaFailoverStatus();
      setIsAlgoliaDown(currentStatus);

      if (!currentStatus) {
        clearInterval(healthCheckInterval);
      }
    }, 60000);

    return () => clearInterval(healthCheckInterval);
  }, [isAlgoliaDown]);

  return { isAlgoliaDown };
};
